.hero {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 10px;
  padding: 0 var(--gutter) 12px;
}

.hero h1 {
  font-size: var(--fs-2xl);
  font-weight: 800;
  letter-spacing: -0.03em;
  line-height: 1.1;
  margin-top: 8px;
}

.desc {
  color: var(--text-2);
  font-size: var(--fs-sm);
  max-width: 340px;
}

.owner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  font-size: var(--fs-sm);
  color: var(--text-3);
}

.owner a {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-weight: 700;
  color: var(--text);
}

.owner span {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.actions {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 6px;
}

.playBig {
  display: grid;
  place-items: center;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: var(--accent);
  color: var(--accent-ink);
  box-shadow: 0 8px 24px rgb(var(--accent-rgb) / 0.3);
  transition: transform var(--t-fast) var(--ease-spring);
}

.playBig:active {
  transform: scale(0.92);
}

.playBig:disabled {
  opacity: 0.4;
}

.tracks {
  padding: 0 8px;
}

.reorder {
  display: inline-flex;
}

.reorderBar {
  position: sticky;
  top: 56px;
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: 0 var(--gutter) 8px;
  padding: 10px 14px;
  border-radius: var(--r-md);
  background: var(--accent-soft);
  border: 1px solid rgb(var(--accent-rgb) / 0.4);
  font-size: var(--fs-xs);
  font-weight: 600;
}

.editor {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 4px 20px 20px;
}

.coverPick {
  position: relative;
  align-self: center;
}

.coverPickBadge {
  position: absolute;
  right: -6px;
  bottom: -6px;
  display: grid;
  place-items: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: var(--accent);
  color: var(--accent-ink);
  box-shadow: 0 0 0 3px var(--surface-1);
}
